import { spacing } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { TFunction } from 'i18next';
import { FaClock } from 'react-icons/fa';
import { CUSTOM_COLOURS } from '../../../../styles';
import { STANDARD_WIDTH } from '../useConsultationStatuses';
import { UseConsultationStatusReturn } from './useConsultationStatusReturn';

export const niConsultationStatusesConfig = (t: TFunction): UseConsultationStatusReturn => {
  return {
    New: {
      label: t('new', 'New'),
      badgeProps: {
        color: COLOURS.black,
        bgColor: CUSTOM_COLOURS.lightGreen,
        width: STANDARD_WIDTH,
      },
    },
    Active: {
      label: t('active', 'Active'),
      badgeProps: { bgColor: COLOURS.blue[600], width: STANDARD_WIDTH },
    },
    'Active isNearingDeadline': {
      label: t('active', 'Active'),
      badgeProps: { bgColor: COLOURS.yellow[500], width: STANDARD_WIDTH },
      icon: FaClock,
    },
    'New information': {
      label: t('new_information', 'New information'),
      badgeProps: {
        bgColor: COLOURS.blue[900],
        width: spacing(32),
      },
    },
    'Re-consultation': {
      label: t('re_consultation', 'Re-consultation'),
      badgeProps: {
        bgColor: CUSTOM_COLOURS.purple,
        width: spacing(31),
      },
    },
    'Extension requested': {
      label: t('extension_requested', 'Extension requested'),
      badgeProps: {
        color: COLOURS.black,
        bgColor: COLOURS.gray[300],
        width: spacing(40),
      },
    },
    'Extension refused': {
      label: t('extension_refused', 'Extension refused'),
      badgeProps: {
        bgColor: COLOURS.red[700],
        width: spacing(37),
      },
    },
    Extended: {
      label: t('extended', 'Extended'),
      badgeProps: {
        bgColor: CUSTOM_COLOURS.darkGreen,
        width: STANDARD_WIDTH,
      },
    },
    Overdue: {
      label: t('overdue', 'Overdue'),
      badgeProps: {
        bgColor: COLOURS.red[700],
        width: STANDARD_WIDTH,
      },
      icon: FaClock,
    },
    'Response rejected': {
      label: t('response_rejected', 'Response rejected'),
      badgeProps: {
        color: COLOURS.white,
        bgColor: COLOURS.red[700],
        width: spacing(35),
      },
    },
    Responded: {
      label: t('responded', 'Responded'),
      badgeProps: {
        color: COLOURS.black,
        bgColor: COLOURS.neutral[10],
        width: STANDARD_WIDTH,
      },
    },
    Closed: {
      label: t('closed', 'Closed'),
      badgeProps: { bgColor: COLOURS.gray[900], width: STANDARD_WIDTH },
    },
    Withdrawn: {
      label: t('withdrawn', 'Withdrawn'),
      badgeProps: {
        color: COLOURS.black,
        bgColor: COLOURS.gray[600],
        width: STANDARD_WIDTH,
      },
    },
    'Consulted in error': {
      label: t('consulted_in_error', 'Consulted in error'),
      badgeProps: {
        bgColor: COLOURS.red[700],
        width: spacing(34),
      },
    },
    Determined: {
      label: t('determined', 'Determined'),
      badgeProps: {
        color: COLOURS.black,
        bgColor: COLOURS.gray[200],
        width: STANDARD_WIDTH,
      },
    },
  };
};
